import { useState, useEffect } from 'react';
import imageCache from '../utils/imageCache';

// Custom hook to get card images with caching
export function useCardImages() {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    // Check if images are already cached
    const checkCacheStatus = () => {
      const sampleImages = ['/card-images/1.jpg', '/card-images/11.jpg', '/card-images/111.jpg'];
      const allCached = sampleImages.every(url => imageCache.isImageCached(url));
      
      if (allCached) {
        setImagesLoaded(true);
      } else {
        // Wait a bit and check again
        setTimeout(checkCacheStatus, 500);
      }
    };

    checkCacheStatus();
  }, []);

  // Return the card images object - these URLs will be cached by the browser
  // after the imageCache preloads them
  const cardImages = {
    cover1: '/card-images/1.jpg',
    cover2: '/card-images/2.jpg',
    cover3: '/card-images/3.jpg',
    cover4: '/card-images/4.jpg',
    cover5: '/card-images/5.jpg',
    cover11: '/card-images/11.jpg',
    cover12: '/card-images/12.jpg',
    cover13: '/card-images/13.jpg',
    cover14: '/card-images/14.jpg',
    cover15: '/card-images/15.jpg',
    cover16: '/card-images/16.jpg',
    cover17: '/card-images/17.jpg',
    cover18: '/card-images/18.jpg',
    cover19: '/card-images/19.jpg',
    cover111: '/card-images/111.jpg',
    cover112: '/card-images/112.jpg',
    cover113: '/card-images/113.jpg',
    cover114: '/card-images/114.jpg',
    cover115: '/card-images/115.jpg',
    cover116: '/card-images/116.jpg',
    cover121: '/card-images/121.jpg',
    cover122: '/card-images/122.jpg',
    cover123: '/card-images/123.jpg',
    cover124: '/card-images/124.jpg',
    cover125: '/card-images/125.jpg',
    cover126: '/card-images/126.jpg',
    cover127: '/card-images/127.jpg',
    cover128: '/card-images/128.jpg',
    cover129: '/card-images/129.jpg',
    cover141: '/card-images/141.jpg',
    cover142: '/card-images/142.jpg',
    cover143: '/card-images/143.jpg',
    cover144: '/card-images/144.jpg',
    cover145: '/card-images/145.jpg',
    cover161: '/card-images/161.jpg',
    cover162: '/card-images/162.jpg',
    cover163: '/card-images/163.jpg',
    cover164: '/card-images/164.jpg',
    cover165: '/card-images/165.jpg',
    cover166: '/card-images/166.jpg',
    cover167: '/card-images/167.jpg',
    cover168: '/card-images/168.jpg',
    cover191: '/card-images/191.jpg',
    cover192: '/card-images/192.jpg',
    cover193: '/card-images/193.jpg'
  };

  return { cardImages, imagesLoaded };
}